import { render, staticRenderFns } from "./info-table.vue?vue&type=template&id=3aaf3f6e&scoped=true&"
import script from "./info-table.vue?vue&type=script&lang=js&"
export * from "./info-table.vue?vue&type=script&lang=js&"
import style0 from "./info-table.vue?vue&type=style&index=0&id=3aaf3f6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aaf3f6e",
  null
  
)

export default component.exports